import { Box, Button, Flex, Image, Text } from '@chakra-ui/react';
import axios from 'axios';
import { useContext, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { AiFillDislike, AiFillLike } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import UserContext from '../../context/userContext';
import Landscape from './landscape.jpg';
import './Search.css';

const Search = () => {
  const [title, setTitle] = useState('');
  const [movies, setMovies] = useState([]);
  const { userData } = useContext(UserContext);
  const user = userData.user;
  const handleInputChanges_Title = e => {
    setTitle(e.target.value);
  };

  const likePost = id => {
    let token = localStorage.getItem('auth-token');
    fetch('https://mern-stack-movies-app.herokuapp.com/movies/like', {
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token,
      },
      body: JSON.stringify({
        postId: id,
      }),
    })
      .then(res => res.json())
      .then(result => {
        const newData = movies.map(movie => {
          if (movie._id === result._id) {
            return result;
          } else {
            return movie;
          }
        });
        setMovies(newData);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const unlikePost = id => {
    let token = localStorage.getItem('auth-token');
    fetch('https://mern-stack-movies-app.herokuapp.com/movies/unlike', {
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token,
      },
      body: JSON.stringify({
        postId: id,
      }),
    })
      .then(res => res.json())
      .then(result => {
        const newData = movies.map(movie => {
          if (movie._id === result._id) {
            return result;
          } else {
            return movie;
          }
        });
        setMovies(newData);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const addFavorites = id => {
    let token = localStorage.getItem('auth-token');
    fetch('https://mern-stack-movies-app.herokuapp.com/movies/addFavorites', {
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token,
      },
      body: JSON.stringify({
        postId: id,
      }),
    })
      .then(res => res.json())
      .then(result => {
        const newData = movies.map(movie => {
          if (movie._id === result._id) {
            return result;
          } else {
            return movie;
          }
        });
        setMovies(newData);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const removeFavorites = id => {
    let token = localStorage.getItem('auth-token');
    fetch(
      'https://mern-stack-movies-app.herokuapp.com/movies/removeFavorites',
      {
        method: 'put',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token,
        },
        body: JSON.stringify({
          postId: id,
        }),
      }
    )
      .then(res => res.json())
      .then(result => {
        const newData = movies.map(movie => {
          if (movie._id === result._id) {
            return result;
          } else {
            return movie;
          }
        });
        setMovies(newData);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const submit = e => {
    e.preventDefault();
    setTitle('');
    axios
      .post('https://mern-stack-movies-app.herokuapp.com/movies/search/name', {
        title,
      })
      .then(res => {
        setMovies(res.data);
        if (res.data.length === 0) {
          const notify = () => toast.error('No movies found!');
          notify();
        }
      })
      .catch(error => {
        const notify = () => toast.error('An error occurred!');
        notify();
        console.log(error);
      })
      .finally(() => {});
  };

  return (
    <>
      <Toaster />
      <Box mt={5}>
        <Flex direction="row" wrap="wrap" justify="center">
          <form onSubmit={submit}>
            <input
              value={title}
              onChange={handleInputChanges_Title}
              type="text"
              placeholder="Search by movie title"
              required
              minlength="3"
              maxlength="30"
            />
            <Button type="submit" colorScheme="messenger" size="lg" mt={3}>
              SEND
            </Button>
          </form>
        </Flex>
      </Box>
      <Box pb={5}>
        <Flex direction="row" wrap="wrap" justify="center">
          {movies ? (
            movies.map((movie, index) => {
              return (
                <Flex
                  key={index}
                  direction="column"
                  align="center"
                  justify="start"
                  textAlign="center"
                  w="300px"
                  border="2px solid #000"
                  mt={10}
                  mx={5}
                  mb={5}
                  bg="#e8ecf1"
                  overflow="hidden"
                >
                  <Image
                    alt=""
                    src={
                      movie.poster === undefined
                        ? `${Landscape}`
                        : `${movie.poster}`
                    }
                    transition="transform 0.5s ease"
                    _hover={{
                      transform: 'translateY(80px) scale(2.0)',
                    }}
                    pb={5}
                  />
                  <Box pb={5} px={5}>
                    <Text fontSize="lg" fontWeight="700" as="u" color="#ff0000">
                      Title
                    </Text>
                    <Text fontSize="lg" color="#000" mt={2} mb={2}>
                      {movie.title}
                    </Text>
                    <Link to={'/movie/' + movie._id}>
                      <Button
                        bg="#f9bf3b"
                        _hover={{
                          background: '#ff0000',
                          color: '#fff',
                        }}
                      >
                        Show info
                      </Button>
                    </Link>
                    {user ? (
                      movie.likes.includes(user.id) ? (
                        <AiFillDislike
                          onClick={() => {
                            unlikePost(movie._id);
                          }}
                          style={{
                            fontSize: 24,
                            marginTop: 20,
                            marginLeft: 20,
                          }}
                        />
                      ) : (
                        <AiFillLike
                          onClick={() => {
                            likePost(movie._id);
                          }}
                          style={{ fontSize: 24, marginTop: 20 }}
                        />
                      )
                    ) : (
                      <Box>
                        <Flex
                          mt={1}
                          direction="row"
                          wrap="wrap"
                          justify="center"
                        >
                          <AiFillLike style={{ fontSize: 24, marginTop: 20 }} />
                          <AiFillDislike
                            style={{
                              fontSize: 24,
                              marginLeft: 20,
                              marginTop: 20,
                            }}
                          />
                        </Flex>
                      </Box>
                    )}
                    <Text fontSize="lg" color="#000" mt={2} mb={2}>
                      {movie.likes.length} likes
                    </Text>
                    <Text
                      fontSize="lg"
                      fontWeight="700"
                      mb={3}
                      as="u"
                      color="#ff0000"
                    >
                      Add to favorites
                    </Text>
                    {user ? (
                      movie.favorites.includes(user.id) ? (
                        <AiFillDislike
                          onClick={() => {
                            removeFavorites(movie._id);
                          }}
                          style={{
                            fontSize: 24,
                            color: '#ff0000',
                            marginTop: 20,
                          }}
                        />
                      ) : (
                        <AiFillLike
                          onClick={() => {
                            addFavorites(movie._id);
                          }}
                          style={{
                            fontSize: 24,
                            color: '#ff0000',
                            marginTop: 20,
                          }}
                        />
                      )
                    ) : (
                      <Box>
                        <Flex
                          mt={1}
                          direction="row"
                          wrap="wrap"
                          justify="center"
                        >
                          <AiFillLike
                            style={{
                              fontSize: 24,
                              color: '#ff0000',
                              marginTop: 20,
                            }}
                          />
                          <AiFillDislike
                            style={{
                              fontSize: 24,
                              color: '#ff0000',
                              marginTop: 20,
                              marginLeft: 20,
                            }}
                          />
                        </Flex>
                      </Box>
                    )}
                  </Box>
                </Flex>
              );
            })
          ) : (
            <Box className="alert">
              <Text fontWeight="700">No movies found</Text>
            </Box>
          )}
        </Flex>
      </Box>
    </>
  );
};

export default Search;
